import axios from 'axios';
import { envs } from './constants';

const axiosInstance = axios.create({
  baseURL: envs.API_URL,
});

axiosInstance.interceptors.request.use((config) => {
  const urlParams = new URLSearchParams(window.location.search);
  const entityType = urlParams.get('entityType');

  if (entityType) {
    config.params = { ...config.params, entityType };
  }

  return config;
});

export default axiosInstance;
